import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@diligentcorp/atlas-react-icons/dist/esm/lens/Close.js';

export interface UnpublishFormConfirmModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  formTitle?: string;
  'data-testid'?: string;
}

export const UnpublishFormConfirmModal = ({
  open,
  setOpen: _setOpen,
  onConfirm,
  onCancel,
  isLoading = false,
  formTitle,
  'data-testid': dataTestId = 'unpublish-form-confirm-modal',
}: UnpublishFormConfirmModalProps) => (
  <Dialog
    open={open}
    onClose={!isLoading ? onCancel : undefined}
    aria-labelledby="unpublish-form-dialog-title"
    aria-describedby="unpublish-form-dialog-description"
    data-testid={dataTestId}
  >
    <DialogTitle component="div">
      <Typography variant="h6" component="h2" id="unpublish-form-dialog-title">
        Unpublish form
      </Typography>
      <IconButton
        aria-label="Close"
        onClick={onCancel}
        disabled={isLoading}
        size="small"
        color="inherit"
        data-testid={`${dataTestId}-close`}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="unpublish-form-dialog-description">
        When you unpublish a form, it no longer appears in Reporter Portal and
        employees can&apos;t use it to start or submit disclosures. Disclosures
        that have already been submitted are not affected.
      </DialogContentText>
      {formTitle && (
        <Typography fontWeight={600} sx={{ mt: 1 }}>
          {formTitle}
        </Typography>
      )}
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'space-between' }}>
      <Button
        variant="outlined"
        onClick={onCancel}
        disabled={isLoading}
        data-testid={`${dataTestId}-cancel`}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        color="destructive"
        onClick={onConfirm}
        disabled={isLoading}
        autoFocus
        data-testid={`${dataTestId}-confirm`}
        startIcon={
          isLoading ? <CircularProgress size={16} color="inherit" /> : undefined
        }
      >
        {isLoading ? 'Unpublishing...' : 'Unpublish'}
      </Button>
    </DialogActions>
  </Dialog>
);
